import styled from 'styled-components'

import {tokens} from '@pleo-io/telescope'

export const Wrapper = styled.div`
    margin: 0 auto;
    padding-bottom: ${tokens.spacing32};

    svg {
        width: 100%;
    }
`

export const Header = styled.div`
    height: 130px;
    background-color: ${tokens.shade200};
`

export const AvatarContainer = styled.div`
    margin-top: -${tokens.spacing36};
    border: 3px solid ${tokens.shade000};
    border-radius: ${tokens.circle};
`
